<h1 class="accent-background-element">Delete User</h1>

<mat-dialog-content>
  <h3 class="warn-text-element">Are you sure you want to delete next user? You will not be able to reverse this step.
  </h3>
  <br>

    <h3>User ID:&nbsp;<span class="not-bold">{{currentUser?.userId}}</span></h3>
    <h3>Role: &nbsp;<span class="not-bold">{{currentUser?.role}}</span></h3>
    <h3>Full Name: &nbsp;<span class="not-bold">{{currentUser?.firstName}} {{currentUser?.lastName}}</span></h3>
    <h3>E-mail:&nbsp; <span class="not-bold">{{currentUser?.email}}</span></h3>
    <h3>Country:&nbsp; @if (currentUser?.country) {
      <span class="not-bold">{{currentUser?.country}}</span>
    } @else {
      <mat-icon svgIcon='dash'></mat-icon>
    }
  </h3>
  @if (currentUser?.role!=UserRolesEnum.ent) {
    <div>
      <h3>
        Clinic:&nbsp; @if (currentClinic?.clinicId) {
        <span class="not-bold">{{[currentClinic?.clinicId, currentClinic?.clinicName,
        currentClinic?.addressLine1,currentClinic?.addressLine2].join(', ')}}</span>
      } @else {
        <mat-icon svgIcon='dash'></mat-icon>
      }</h3>
    </div>
  }
  @if (currentUser?.role==UserRolesEnum.ent) {
    <div>
      <h3>
        ENT Office:&nbsp; @if (currentOffice?.entOfficeId) {
        <span class="not-bold">{{[currentOffice?.entOfficeId, currentOffice?.entOfficeName,
        currentOffice?.addressLine1,currentOffice?.addressLine2].join(', ')}}</span>
      } @else {
        <mat-icon svgIcon='dash'></mat-icon>
      }</h3>
    </div>
  }

  <h3>Language:&nbsp; <span class="not-bold">{{currentUser?.lang}}</span></h3>

</mat-dialog-content>

<mat-dialog-actions>
  <button mat-raised-button color="accent" (click)="exit()">No</button>
  <span class="spacer"></span>
  <button mat-raised-button color="warn" (click)="onSubmit()">Yes</button>
</mat-dialog-actions>

